<template>
<div class="left-zhu">
  <div class="header-top">
  <p class="header-logo"><img src="https://jbh.sxjbhyy.com/S2022010518000079.png"></p>
 </div>
    <scroll-bar>
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
      unique-opened
      class="topheader"
    >
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </scroll-bar>
</div>

</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'

export default {
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters([
      'sidebar',
      'routers'
    ]),
    routes() {
      // return this.$router.options.routes
      return this.routers
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  data(){
    return{
      userName:'Zhwg',
      roleName:'店长'
    }
  }
}
</script>
<style lang="scss">
.left-zhu{
  position: relative;
}
  .header-top{
    height: 120px;
    text-align: center;
    background-color:#304156 ;
    cursor: pointer;
   .header-tou{
    margin: top 5px;
  img{
    width: 100px;
    height: 100px;
    border-radius: 10px;
  }
  } 
   .header-logo img{
     margin-top: 20px;
      width: 180px;
      height: 60px;
  }
  .header-xin{
    span{
      margin-right: 10px;
      display: inline-block;
      height: 40px;
      line-height: 40px;
     color: #fff;
     font-size: 14px;
    }
  }
  }
  // .topheader{
  //   overflow: auto;
  // }
 .bottom-logo{
   width: 100%;
   min-height: 60px;
   div{
     width: 100%;
     height: 30px;
     font-size: 14px;
     color: #aebac9;
     text-align: center;
   }
 }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue